import Box from '@mui/material/Box';
import { Trans } from "react-i18next";
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Edit from '@mui/icons-material/Edit';
import Save from '@mui/icons-material/Save';
import UserDataForm from './userDataForm';
import { Form, Formik } from "formik";
import InputField from '../../../components/formFields/InputField';
import ProfileGoingOutDialog from './ProfileGoingOutDialog';
import ProfileContext from './ProfileContext';

type EditingState = {
  fieldsDisabled: [boolean, boolean, boolean],
  profileCardHeaderClass: string,
  textFieldClass: string
}

const Editing: EditingState = {
  fieldsDisabled: [true, true, false],
  profileCardHeaderClass: "profile-card-header editing",
  textFieldClass: "profile"
}

const NotEditing: EditingState = {
  fieldsDisabled: [true, true, true],
  profileCardHeaderClass: "profile-card-header",
  textFieldClass: "profile informational"
}

export default function () {

  return (
    <ProfileContext.Consumer>
      { context => {
        const editingState: EditingState = context.editing ? Editing : NotEditing

        const edit = () => context.setEditing(true)

        const onChange = (values: any) => context.formValues = values
        
        return (
          <Box sx={{marginBottom: '30px'}}>
            <Formik
              initialValues={{phone: context.userData.phone}}
              onSubmit={context.update}
              validationSchema={UserDataForm.validationSchema}
              isInitialValid={false}
            >
              {({ isSubmitting, isValid, values }) => (
                <Form id="user-data" onChange={() => onChange(values)}>
                  <Box className={editingState.profileCardHeaderClass} sx={{display: 'flex'}}>
                    <Box className='profile-card-title' sx={{flexGrow: 1}}>
                      <Trans i18nKey={`screens.profile.sections.personalData.title`}></Trans>
                    </Box>
                    <Box sx={{marginRight: '32px', marginTop: 'auto',  marginBottom: 'auto'}}>
                    { context.editing &&
                      <IconButton disabled={!isValid || isSubmitting} size="small" type='submit' className="profile-card-save-icon">
                        <Save fontSize="small" />
                      </IconButton>
                    }
                    { !context.editing && 
                      <IconButton size="small" onClick={edit}>
                        <Edit fontSize="small" />
                      </IconButton>
                    }
                    </Box>
                  </Box>
                  <Box className='profile-card-body'>
                    <TextField
                      label={<Trans i18nKey={`screens.profile.sections.personalData.idLabel`}></Trans>}
                      disabled={editingState.fieldsDisabled[0]}
                      fullWidth={true}
                      defaultValue={context.userData.dni}
                      variant={context.editing ? 'filled' : 'standard'}
                      className={editingState.textFieldClass}
                    />
                    <TextField
                      label={<Trans i18nKey={`screens.profile.sections.personalData.emailLabel`}></Trans>}
                      disabled={editingState.fieldsDisabled[1]}
                      fullWidth={true}
                      defaultValue={context.userData.email}
                      variant={context.editing ? 'filled' : 'standard'}
                      className={editingState.textFieldClass}
                      sx={context.editing ? {margin: "20px 0"} : {margin: "32px 0 42px"}}
                    />
                    <InputField
                      label={`screens.profile.sections.personalData.phoneLabel`}
                      disabled={editingState.fieldsDisabled[2]}
                      className={editingState.textFieldClass}
                      name='phone'
                      fullWidth
                      type="number"
                    />
                  </Box>
                </Form>
              )}
            </Formik>
            <ProfileGoingOutDialog></ProfileGoingOutDialog>
          </Box>
        )
      }}
    </ProfileContext.Consumer>
  );
}